module.exports = __webpack_public_path__ + "static/media/5efb022d8661d7beabf03e9f.2e90e6c9.png";